import React, { useState, useEffect } from "react";

interface OTPTimerProps {
  count: number;
  setCount: any;
  counter: number;
  setCounter: any;
}

function Timer(props: OTPTimerProps) {
  const getFormattedTime = (time: number) => {
    if (time < 10) {
      return "0" + time;
    } else {
      return time;
    }
  };

  useEffect(() => {
    const timer =
      props.counter > 0 && setTimeout(() =>  props.setCounter(props.counter - 1), 1000);

    if (props.counter == 0) {
      props.setCount(props.count + 1);
    }

    return () => clearInterval(Number(timer));
  }, [props.counter]);

  return (
    <div>
      {/* <div>00:{getFormattedTime(props.counter)}</div> */}
      <p>{`0${Math.floor(props.counter / 60)}:${props.counter % 60 < 10 ? '0' : ''}${props.counter % 60}`}</p>
    </div>
  );
}
export default Timer;
